import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';
const tobaccoHumidityRoomProductionsApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorTobaccoHumidityRoomProduction/byDates`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default tobaccoHumidityRoomProductionsApi;
